import { Link } from 'react-router-dom';
import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="container-custom py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-2xl font-bold tracking-wider text-primary-400 whitespace-nowrap">
              {footerData.company}
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-100/60">
              {footerData.slogan}
            </p>
            <div className="flex items-center space-x-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-100 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-100 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-100 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">快速导航</h4>
            <ul className="space-y-3">
              {footerData.quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-100/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">核心服务</h4>
            <ul className="space-y-3">
              {footerData.services.map((service) => (
                <li key={service.href}>
                  <Link
                    to={service.href}
                    className="text-sm text-foreground-100/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-100/60">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line mt-0.5 text-primary-400" />
                <span>{footerData.contact.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-primary-400" />
                <span>{footerData.contact.phone}</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-primary-400" />
                <span>{footerData.contact.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-100/40">
            © {new Date().getFullYear()} {footerData.company} 版权所有
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-xs text-foreground-100/40 hover:text-foreground-100/60 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-100/40 hover:text-foreground-100/60 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-100/40 hover:text-foreground-100/60 transition-colors cursor-pointer whitespace-nowrap">会员协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}